import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/SubmitVoteButton';
// FOR ONE GRAPHQL QUERY
export const SUBMIT_VOTE = defineAsyncActionTypes(`${prefix}/SUBMIT_VOTE`);

export const UPDATE_TRIGGER_CASTING = `${prefix}/UPDATE_TRIGGER_CASTING`;

export const RESERVE_VOTE = defineAsyncActionTypes(`${prefix}/RESERVE_VOTE`);



// WEBPACK FOOTER //
// ./src/store/graphql/SubmitVoteButton/action-types.js